import React from 'react';
import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <div className="language-switcher">
            <button
                onClick={() => changeLanguage('en')}
                className={`lang-btn ${i18n.language === 'en' ? 'active' : ''}`}
            >
                EN
            </button>
            <button
                onClick={() => changeLanguage('ja')}
                className={`lang-btn ${i18n.language === 'ja' ? 'active' : ''}`}
            >
                日本語
            </button>
        </div>
    );
} 